import { Row, Section } from '@advanza/advanza_generic'
import { Divider } from '@advanza/ui'
import Page from 'components/ui/Page'
import React from 'react'
import ProfileReportGenerator from './ProfileReportGenerator'

const ProfileReportPage = ({}) => {
    return (
        <Page title="Providers">
            <div style={{ margin: 'auto', maxWidth: 1200 }}>
                <Section e="plus">
                    <h1>Profile Report</h1>
                </Section>
                <Divider l></Divider>
                <ProfileReportGenerator />
            </div>
        </Page>
    )
}

ProfileReportPage.propTypes = {}

export default ProfileReportPage
